var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ci-icon',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.pipelineTooltipText,"status":_vm.pipeline.detailedStatus,"show-tooltip":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }